// extracted by mini-css-extract-plugin
export default {"terms":"styles-module__terms___eRbk3","articles":"styles-module__articles___RIqgs","blurred":"styles-module__blurred___OPfSW"};